import { useQuery, UseQueryResult } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { TierResponse } from '../AccountLimitsType';

interface useGetLimitsTierProps {
  customerId: string;
  accountExternalId: string;
}

export const useGetLimitsTier = ({
  customerId,
  accountExternalId,
}: useGetLimitsTierProps): UseQueryResult<TierResponse, Error> =>
  useQuery<TierResponse, Error>(
    'useGetLimitsTier',
    async () => {
      const res = await httpService.get<TierResponse>(
        `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/limits/tierInfo`,
      );

      return res.data;
    },
    {
      enabled: false,
      retry: 0,
      staleTime: 0,
      cacheTime: 0,
    },
  );
